import React, { Component } from "react";
import { connect } from "react-redux";
import { Toggle } from "office-ui-fabric-react/lib/Toggle";

import { toggleArchivedShipments } from "../../actions/ui_actions";
import { deselectAll } from "../../actions/select_actions";

class ArchiveSwitch extends Component {
  onChangedToggle = () => {
    this.props.deselectAll();
    this.props.toggle();
  };

  render() {
    return (
      <Toggle
        checked={this.props.visible}
        offText="Show archived shipments"
        onText="Hide archived shipments"
        onChanged={this.onChangedToggle}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    visible: state.ui.isArchivedShipmentsVisible
  };
};

export default connect(mapStateToProps, {
  toggle: toggleArchivedShipments,
  deselectAll: deselectAll
})(ArchiveSwitch);



// WEBPACK FOOTER //
// ./src/common/Buttons/_ArchiveSwitch.js